import moment from "moment";
import employeeProfile from "./S070200-EmployeeProfile/S070200-EmployeeProfile.vue";
import employeeLetters from "./S070200-EmployeeLetters/S070200-EmployeeLetters.vue";
import employeeProbation from "./S070200-EmployeeProbation/S070200-EmployeeProbation.vue";
import DatePicker from "vue2-datepicker";
import StaffService from "@/service/StaffService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import TreeNodeHelper from "@/common/helper/TreeNodeHelper";
import ArrayHelper from "@/common/helper/ArrayHelper";
import { StaffEmployment } from "@/model/StaffEmployment";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Settings from "../../constants/Settings";
export default {
  components: {
    DatePicker,
    employeeProfile,
    employeeLetters,
    employeeProbation
  },
  data: () => ({
    t: t,
    dictEnum: dictEnum,
    tab: null,
    Alluser:[],
    date: new Date(),
    type: "date",
    staffList: [],
    IsEditButton: false,
    isInActiveStaff: false,
    staffId: "",
    treeViewOpen: ["Root"],
    caseSensitive: false,
    selectedTab: "employeeProfile",
    selectedComp: "",
    compList: []
  }),
  computed: {
    formattedDate() {
      return this.date && moment(this.date).format(Settings.DateTime.yyyymmdd) != "1900-01-01"
        ? moment(this.date).format(Settings.DateTime.yyyymmdd)
        : undefined;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].includes(search)
        : undefined;
    },
      filteredStaffTree() {
        let list = this.$data.staffList;
        if (this.$data.staffId != "") {
          const filterNode = (node) => {
          const matches = !this.staffId || node.StaffID.includes(this.staffId) || node.name.toLowerCase().includes(this.staffId.toLowerCase());
          if (node.children) {
            const filteredChildren = node.children.map(child => filterNode.call(this, child)).filter(child => child !== null);
            //如果有子节点匹配，也返回当前父节点
             if (filteredChildren.length > 0) {
              return { ...node, children: filteredChildren };
            }
          }
          return matches ? node : null;
        };
        const filterTree = (tree) => {
          return tree.map(node => filterNode(node)).filter(node => node !== null);
        };
        return filterTree(this.staffTree);
      }
      if (this.selectedComp) {
        list = list.filter((x) => x.CompCode == this.selectedComp)
      }
      const tree = TreeNodeHelper.flattenToTree(
        list,
        "StaffID",
        "ChildStaffs",
        "SupervisorID"
      );
      this.treeViewOpen = tree.map((user) => user.StaffID);
      return tree;
  },
    staffTree() {
      let list = this.$data.staffList;
      if (this.$data.staffId != "") {
        list = list.filter((x) => this.wildCardSearch(x, this.$data.staffId.toLowerCase()))
      }
      if (this.selectedComp) {
        list = list.filter((x) => x.CompCode == this.selectedComp)
      }
      const tree = TreeNodeHelper.flattenToTree(
        list,
        "StaffID",
        "ChildStaffs",
        "SupervisorID"
      );
      this.treeViewOpen = tree.map((user) => user.StaffID);
      return tree;
    },
    staffNum() {
      let num = 0;
      const list = this.staffTree;
      list.forEach((x) => {
        num = num + this.staffChildNum(x)
      })
      return num;
    }
  },
  mounted() {
    this.getStaffList();
    this.getCompanyList();
  },
  methods: {
    
flattenStaffList(staffList) {
  // 输入校验
  if (!Array.isArray(staffList)) {
    return [];
  }
  let result = [];
  function flatten(list) {
    for (let item of list) {
      // 推入当前项（浅拷贝）
      result.push({ ...item });
      // 如果存在子级，递归处理
      if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        flatten(item.children);
      }
    }
  }
  flatten(staffList);
  return result;
},
    selectInActiveStaff() {
      var self = this;
      self.getStaffList();
    },
    searchStaff() {
      var self = this;
      self.getStaffList();
    },

    staffChildNum(staff) {
      let num = 1;
      if (staff.children.length > 0) {
        staff.children.forEach((x) => {
          num = num + this.staffChildNum(x);
        })
      }
      return num;
    },

    wildCardSearch(obj, keyword) {
      if (this.user.Lang == "EN") {
        obj.name = obj["EngName"] + obj["EngLastName"];
      } else {
        obj.name = obj["ChiLastName"] + obj["ChiName"];
      }
      for (const [key, value] of Object.entries(obj)) {
        if (JSON.stringify(value).toLowerCase().includes(keyword)) return true;
      }
      return false;
    },

    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      var self = this;
      const obj = {
        isInActiveStaff: self.isInActiveStaff,
        staffId: ""
      };
      const response = await StaffService.getStaffLists(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
        this.$data.Alluser= this.flattenStaffList(response.data.Data);
        console.log(this.$data.Alluser,'所有员工信息');
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async onSelectStaff(staff) {
      var self = this;
      const obj = {
        staffId: staff.StaffID,
      };
      const response = await StaffService.getStaffDetail(obj);
      if (response.data.IsSuccess) {
        self.IsEditButton = true;
        self.$refs.refEmployeeProfile.$data.mode = '';
        self.$refs.refEmployeeProfile.$data.IsEditButton = true;
        self.$refs.refEmployeeProfile.$data.isViewMode = true;
        self.$refs.refEmployeeProfile.clearFilterValue();
        var staffDetail = response.data.Data;
        staffDetail.SkillCertList = [];
        self.$refs.refEmployeeProfile.$data.staff = staffDetail;

        // self.$refs.refEmployeeProfile.$data.staff.StaffID = staffDetail.StaffID;
        // self.$refs.refEmployeeProfile.$data.staff.StaffType = staffDetail.StaffType;
        // self.$refs.refEmployeeProfile.$data.staff.CompCode = staffDetail.CompCode;
        // self.$refs.refEmployeeProfile.$data.staff.EngName = staffDetail.EngName;
        // self.$refs.refEmployeeProfile.$data.staff.EngLastName = staffDetail.EngLastName;
        // self.$refs.refEmployeeProfile.$data.staff.ChiName = staffDetail.ChiName;
        // self.$refs.refEmployeeProfile.$data.staff.ChiLastName = staffDetail.ChiLastName;
        // self.$refs.refEmployeeProfile.$data.staff.BadgeNum = staffDetail.BadgeNum;
        // self.$refs.refEmployeeProfile.$data.staff.DocTypeCode = staffDetail.DocTypeCode;
        // self.$refs.refEmployeeProfile.$data.staff.DocNum = staffDetail.DocNum;
        // self.$refs.refEmployeeProfile.$data.staff.EmpRef = staffDetail.EmpRef;
        // self.$refs.refEmployeeProfile.$data.staff.POB = staffDetail.POB;
        // self.$refs.refEmployeeProfile.$data.staff.Gender = staffDetail.Gender;
        // self.$refs.refEmployeeProfile.$data.staff.Country = staffDetail.Country;
        // self.$refs.refEmployeeProfile.$data.staff.District = staffDetail.District;
        // self.$refs.refEmployeeProfile.$data.staff.Area = staffDetail.Area;
        // self.$refs.refEmployeeProfile.$data.staff.Addr = staffDetail.Addr;
        // self.$refs.refEmployeeProfile.$data.staff.Email = staffDetail.Email;
        // self.$refs.refEmployeeProfile.$data.staff.Mobile = staffDetail.Mobile;
        // self.$refs.refEmployeeProfile.$data.staff.BankCode = staffDetail.BankCode;
        // self.$refs.refEmployeeProfile.$data.staff.BankAcNum = staffDetail.BankAcNum;
        // self.$refs.refEmployeeProfile.$data.staff.AcHolderName = staffDetail.AcHolderName;
        // self.$refs.refEmployeeProfile.$data.staff.Dept = staffDetail.Dept;
        // self.$refs.refEmployeeProfile.$data.staff.DOB = staffDetail.DOB;
        // self.$refs.refEmployeeProfile.$data.staff.MaritalStatus = staffDetail.MaritalStatus;
        // self.$refs.refEmployeeProfile.$data.staff.SupervisorID = staffDetail.SupervisorID;
        // self.$refs.refEmployeeProfile.$data.staff.PhotoURL = staffDetail.PhotoURL;
        // self.$refs.refEmployeeProfile.$data.staff.Photo = staffDetail.Photo;
        // self.$refs.refEmployeeProfile.$data.staff.LetterHead = staffDetail.LetterHead;
        // self.$refs.refEmployeeProfile.$data.staff.StaffEmgConts = staffDetail.StaffEmgConts;
        // self.$refs.refEmployeeProfile.$data.staff.StaffBenefitList = staffDetail.StaffBenefitList;
        // self.$refs.refEmployeeProfile.$data.staff.StaffEmployment = staffDetail.StaffEmployment;
        // self.$refs.refEmployeeProfile.$data.staff.StaffJobHistoryList = staffDetail.StaffJobHistoryList;
        // self.$refs.refEmployeeProfile.$data.staff.StaffAcademicList = staffDetail.StaffAcademicList;
        // self.$refs.refEmployeeProfile.$data.staff.StaffEmployHistoryList = staffDetail.StaffEmployHistoryList;
        // self.$refs.refEmployeeProfile.$data.staff.StaffEmploymentList = staffDetail.StaffEmploymentList;
        // self.$refs.refEmployeeProfile.$data.staff.StaffSkillCertsList = staffDetail.StaffSkillCertsList;
        // self.$refs.refEmployeeProfile.$data.staff.StaffAttachmentList = staffDetail.StaffAttachmentList;
        // self.$refs.refEmployeeProfile.$data.staff.DateResign = staffDetail.DateResign;
        // self.$refs.refEmployeeProfile.$data.staff.StaffFixAlwList = staffDetail.StaffFixAlwList;

        self.$refs.refEmployeeProfile.$data.EmployeeProfileTab = 0;
        self.$refs.refEmployeeProfile.changeTab('employeeProfile')
        // self.$refs.refEmployeeProfile.$data.staff.Pwd = '';
        if (self.$refs.refEmployeeProfile.$data.staff.StaffEmploymentList == null || self.$refs.refEmployeeProfile.$data.staff.StaffEmploymentList.length == 0) {
          self.$refs.refEmployeeProfile.$data.staff.StaffEmployment = new StaffEmployment();
        }
        else {
          self.$refs.refEmployeeProfile.$data.staff.StaffEmployment = self.$refs.refEmployeeProfile.$data.staff.StaffEmploymentList[0];
        }
        if (self.$refs.refEmployeeProfile.$data.staff.DOB != null && self.$refs.refEmployeeProfile.$data.staff.DOB != "") {
          self.$refs.refEmployeeProfile.$data.staff.DOB = moment(
            String(self.$refs.refEmployeeProfile.$data.staff.DOB)
          ).format(Settings.DateTime.yyyymmdd);
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateJoin != null && self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateJoin != "") {
          self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateJoin = moment(
            String(self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateJoin)
          ).format(Settings.DateTime.yyyymmdd);
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateProbatEnd != null && self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateProbatEnd != "") {
          self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateProbatEnd = moment(
            String(self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateProbatEnd)
          ).format(Settings.DateTime.yyyymmdd);
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateTerm != null && self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateTerm != "") {
          var dateTerm = moment(String(self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateTerm)).format(Settings.DateTime.yyyymmdd);
          if (dateTerm == '1900-01-01') {
            self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateTerm = "";
          }
          else
            self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateTerm = dateTerm;
        }
        if(staffDetail.CalMethod!=null){
          self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.CalMethod=staffDetail.CalMethod;
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateLastWork != null && self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateLastWork != "") {
          var dateLastWork = moment(String(self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateLastWork)).format(Settings.DateTime.yyyymmdd);
          if (dateLastWork == '1900-01-01') {
            self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateLastWork = "";
          }
          else
            self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.DateLastWork = dateLastWork;
        }
        if (self.$refs.refEmployeeProfile.$data.staff.Country != "") {
          var districtList = self.$refs.refEmployeeProfile.$data.locationList.filter(
            (obj) =>
              obj.Country ==
              self.$refs.refEmployeeProfile.$data.staff.Country &&
              obj.Area == "" &&
              obj.District != "" &&
              obj.District != "-"
          );
          self.$refs.refEmployeeProfile.$data.districtList = districtList;
        }
        if (self.$refs.refEmployeeProfile.$data.staff.District != "") {
          var areaList = self.$refs.refEmployeeProfile.$data.locationList.filter(
            (obj) =>
              obj.District ==
              self.$refs.refEmployeeProfile.$data.staff.District &&
              obj.Area != "" &&
              obj.Area != "-"
          );
          self.$refs.refEmployeeProfile.$data.areaList = areaList;
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffEmgConts.length > 0) {
          var tempCode = 1;
          self.$refs.refEmployeeProfile.$data.staff.StaffEmgConts.forEach(
            (element) => {
              element.tempCode = tempCode;
              element.IsEditMode = false;
              var relationshipDetail = self.$refs.refEmployeeProfile.$refs.refEmergencyContact.$data.relationshipList.find(
                (obj) => obj.RelateType == element.RelateType
              );
              element.RelateTypeDes =
                self.user.Lang == "EN"
                  ? relationshipDetail.EDesc
                  : relationshipDetail.CDesc;
              element.EmgCont = element.EmgCont ? "true" : "false";
              tempCode++;
            }
          );
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffBenefitList.length > 0) {
          var tempCode = 1;
          self.$refs.refEmployeeProfile.$data.staff.StaffBenefitList.forEach(
            (element) => {
              element.tempCode = tempCode;
              element.IsEditMode = false;
              element.DateEff = moment(String(element.DateEff)).format(Settings.DateTime.yyyymmdd);
              element.DateExp = moment(String(element.DateExp)).format(Settings.DateTime.yyyymmdd);
              tempCode++;
            }
          );
          self.$refs.refEmployeeProfile.$refs.refStaffBenefit.getAllBenefit();
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffJobHistoryList.length > 0) {
          var tempCode = 1;
          self.$refs.refEmployeeProfile.$data.staff.StaffJobHistoryList.forEach(
            (element) => {
              if (element.DocMime != null && element.DocMime != "") {
                element.IsImageFile = element.DocMime.indexOf("image") != -1 ? true : false;
              }
              element.tempCode = tempCode;
              element.IsEditMode = false;
              element.DateJoin = moment(String(element.DateJoin)).format(Settings.DateTime.yyyymmdd);
              element.DateResign = moment(String(element.DateResign)).format(Settings.DateTime.yyyymmdd);
              var employTypeDetail = self.$refs.refEmployeeProfile.$refs.refEmployeeJobHistory.$data.employTypeList.find(
                (obj) => obj.EmpType == element.EmpType
              );
              element.EmployTypeDes =
                self.user.Lang == "EN"
                  ? employTypeDetail.EDesc
                  : employTypeDetail.CDesc;
              tempCode++;
            }
          );
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffAcademicList != null && self.$refs.refEmployeeProfile.$data.staff.StaffAcademicList.length > 0) {
          var tempCode = 1;
          self.$refs.refEmployeeProfile.$data.staff.StaffAcademicList.forEach(
            (element) => {
              if (element.DocMime != null && element.DocMime != "") {
                element.IsImageFile = element.DocMime.indexOf("image") != -1 ? true : false;
              }
              element.tempCode = tempCode;
              element.IsEditMode = false;
              element.DateFrom = moment(String(element.DateFrom)).format(Settings.DateTime.yyyymmdd);
              element.DateTo = moment(String(element.DateTo)).format(Settings.DateTime.yyyymmdd);
              var academicDetail = self.$refs.refEmployeeProfile.$refs.refStaffAcademic.$data.academicList.find(
                (obj) => obj.AcademicCode == element.AcademicCode
              );
              element.AcademicDes =
                self.user.Lang == "EN"
                  ? academicDetail.EDesc
                  : academicDetail.CDesc;
              tempCode++;
            }
          );
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffAttachmentList != null && self.$refs.refEmployeeProfile.$data.staff.StaffAttachmentList.length > 0) {
          self.$refs.refEmployeeProfile.$data.staff.StaffAttachmentList.forEach(
            (element) => {
              if (element.DocMime != null && element.DocMime != "") {
                element.IsImageFile = element.DocMime.indexOf("image") != -1 ? true : false;
              }
            });
        }
        if (self.$refs.refEmployeeProfile.$data.staff.StaffEmployHistoryList != null && self.$refs.refEmployeeProfile.$data.staff.StaffEmployHistoryList.length > 0) {
          self.$refs.refEmployeeProfile.$data.staff.StaffEmployHistoryList.forEach(
            (element) => {
              element.DateLastWork = element.DateLastWork ? moment(String(element.DateLastWork)).format(Settings.DateTime.yyyymmdd) : '1900-01-01';
            }
          );
        }
        self.$refs.refEmployeeProfile.$refs.refSkillCert.getAllSkillCertList();
        self.$refs.refEmployeeProfile.disabledStartDate();
        self.$refs.refEmployeeLetters.$data.staff = self.$refs.refEmployeeProfile.$data.staff;
        self.$refs.refEmployeeLetters.resetStaffLetterData();
        self.$refs.refEmployeeLetters.getStaffLetterList();
        self.$refs.refEmployeeProbation.$data.staff = self.$refs.refEmployeeProfile.$data.staff;
        self.$refs.refEmployeeProbation.resetStaffProbation();
        self.$refs.refEmployeeProbation.getAllStaffProbationList();
        var jobDetail = self.$refs.refEmployeeProfile.$refs.refEmployment.$data.jobCodeList.find(
          (obj) => obj.JobCode == self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.JobCode
        );
        if (jobDetail != null && jobDetail != undefined) {
          var jobName = self.user.Lang == 'EN' ? jobDetail.EDesc : jobDetail.CDesc;
          self.$refs.refEmployeeProfile.$data.staff.StaffEmployment.JobName = jobName;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
        self.$refs.refEmployeeProfile.initStaff();
      }
    },

    changeTab: function (tab) {
      var self = this;
      switch (tab) {
        case 'employeeProfile':
          break;
        case 'employeeProbation':
          break;
        case 'employeeLetter':
          setTimeout(function () {
            self.$refs.refEmployeeLetters.init();
          }, 1000);
          break;
      }
      self.selectedTab = tab;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070100-Employee.js